export default "__VITE_ASSET__917a8d44__"